import ApartmentDataGrid from './ApartmentDataGrid';

export default ApartmentDataGrid;
